import { AnyAction, Dispatch } from 'redux';

export interface AdminDetail {
  id: string;
  firstName?: string | null;
  lastName?: string | null;
  email?: string | null;
}

export interface OrganizationChoice {
  id: string;
  name?: string | null;
  jobTitle?: string | null;
  PCAOBNumOfIssuers?: string | number | null;
}

export type SetMembershipEvent = (key: string, value: unknown) => AnyAction;
export type SetMembershipPackageOrganization<TOrg> = (payload: TOrg) => AnyAction;
export type SetMembershipApplicationAdminDetail<TAdmin> = (payload: TAdmin) => AnyAction;

export type HandleCentersRenewalDeps<TOrg = OrganizationChoice, TAdmin = AdminDetail> = {
  centerMembershipId?: string | null;
  renewalUrl: string;
  organizationChoice: TOrg;
  adminDetail: TAdmin;

  dispatch: Dispatch<AnyAction>;
  setMembershipEvent: SetMembershipEvent;
  setMembershipPackageOrganization: SetMembershipPackageOrganization<TOrg>;
  setMembershipApplicationAdminDetail: SetMembershipApplicationAdminDetail<TAdmin>;
  history: { push: (path: string) => void };
};

export function handleCentersRenewal({
  centerMembershipId,
  renewalUrl,
  organizationChoice,
  adminDetail,
  dispatch,
  setMembershipEvent,
  setMembershipPackageOrganization,
  setMembershipApplicationAdminDetail,
  history,
}: HandleCentersRenewalDeps): void {
  if (!centerMembershipId) return;

  dispatch(setMembershipEvent('isClickedCenterMembershipJourney', true));
  dispatch(setMembershipPackageOrganization(organizationChoice));
  dispatch(setMembershipApplicationAdminDetail(adminDetail));

  return history.push(renewalUrl);
}
